import { useEffect, useState } from "react";
import { useQueryClient } from "react-query";
import { useForm, FormProvider } from "react-hook-form";
import { useRecoilState, useRecoilValue } from "recoil";
import { accountAtom } from "../../../Login/atoms/AccountAtom";
import {
  officeAddState,
  officeEditState,
  rowForEditOfficeSettings,
  franchiseCheckBox,
  officeFromOH,
  officeShowState,
  workFromHome,
  officeImageAttachment,
  fileImageForDelete,
  rowImageForDelete,
  imageDisplays,
  changeToUpdate,
  branchManagerChanged,
  associatedEmployeeId,
  fromEmpReportsModal,
  disabled,
} from "../atoms/atoms";
import SubmitHookForm from "../../../../components/SubmitHookForm";
import CancelButton from "../../../../components/CancelButton";
import ConfirmBoxModal from "../../../../components/ConfirmBoxModal";
//Dropdown Data Path
import useAddOfficeSettings from "../hooks/useAddOfficeSettings";
import useEditOfficeSettings from "../hooks/useEditOfficeSettings";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../../PermissionsConstants";
import { toast } from "../../../../components/toastNotification";
import { useHistory } from "react-router";
import OfficeGeneralInfo from "./OfficeGeneralInfo";
import OfficeHours from "./OfficeHours";
import {
  IOfficeDetails,
  IOfficeHierarchyDeatils,
  IOfficeHoursList,
} from "../types";
import OfficeAddress from "./OfficeAddress";
import OfficeMappingData from "./OfficeMappingData";
import OfficeHierarchy from "./OfficeHierarchy";
import { CarrierAgreementMgmtTabs } from "../../carrierAgreementTabs";
import { mainSelectedTab } from "../../atoms";
import OfficeBIandA from "./OfficeBIandA";
import OfficeDates from "./OfficeDates";
import OfficeFacilities from "./OfficeFacilities";
import { useGetActiveOfficeStatus } from "../hooks/useGetActiveOfficeStatus";
import useSendEmail from "../hooks/useSendEmail";
import OfficeImageSectionForm from "./OfficeImageSectionForm";
import EmployeeReportsToModal from "../modals/EmployeeReportsToModal";
import { useGetEmployeeReportsCount } from "../hooks/useGetEmployeeReportsToCount";
import { useGetEmployeesAssociatedToOffice } from "../hooks/useGetEmployeesAssociatedToOffice";
import OfficeTelecom from "./OfficeTelecom";
import SPLCHierarchy from "./SPLCHierarchySection";
import { OFFICE_PERMISSIONS } from "../permission";

const OfficeSettingsForm = ({ searchRefetch }) => {
  const queryClient = useQueryClient();
  const user = useRecoilValue(accountAtom);
  const [saveModal, setSaveModal] = useState(false);
  const [reportsToConfirmationModal, setReportsToConfirmationModal] =
    useState(false);
  const [managerChanged, setManagerChanged] =
    useRecoilState(branchManagerChanged);
  const [showEmployeeReportsTo, setShowEmployeeReportsTo] = useState(false);
  const [newData, setNewData] = useState<IOfficeDetails>();
  const [isAddState, setAddState] = useRecoilState(officeAddState);
  const [isEditState, setEditState] = useRecoilState(officeEditState);
  const [rowForEdit, setRowToEdit] = useRecoilState(rowForEditOfficeSettings);
  const [, setValidWorkFromHome] = useRecoilState(workFromHome);
  const [, setFranchiseCheckBoxValue] = useRecoilState(franchiseCheckBox);
  const [, setShowState] = useRecoilState(officeShowState);
  const imageDisplay = useRecoilValue(imageDisplays);
  // Get Employeees associated to Office
  const { data: empOffice } = useGetEmployeesAssociatedToOffice();

  const history = useHistory();
  // Add Office Initialization
  const { mutate: addofficeSettings } = useAddOfficeSettings();

  //Edit Office Initialization// Add Office Initialization
  const { mutate: editofficeSettings } = useEditOfficeSettings();

  //permissions
  //General Information
  const viewGeneralInfoPermission =
    OFFICE_PERMISSIONS.permission_office_generalinformation_view;
  const addGeneralInfoPermission =
    OFFICE_PERMISSIONS.permission_office_generalinformation_add;
  const editGeneralInfoPermission =
    OFFICE_PERMISSIONS.permission_office_generalinformation_edit;
  //Office Hierarchy
  const viewOfficeHierarchyPermission =
    OFFICE_PERMISSIONS.permission_office_officehierarchy_view;
  const editOfficeHierarchyPermission =
    OFFICE_PERMISSIONS.permission_office_officehierarchy_edit;
  //SPLC Hierarchy
  const viewSplcHierarchyPermission = PERMISSIONS.permission_hierarchy_view;
  const editSplcHierarchyPermission = PERMISSIONS.permission_hierarchy_update;
  //Office Address
  const viewOfficeAddress = OFFICE_PERMISSIONS.permission_office_address_view;
  const addOfficeAddress = OFFICE_PERMISSIONS.permission_office_address_add;
  const editOfficeAddress = OFFICE_PERMISSIONS.permission_office_address_edit;
  //Office Hours
  const viewOfficeHoursPermission =
    OFFICE_PERMISSIONS.permission_office_officehours_view;
  const addOfficeHoursPermission =
    OFFICE_PERMISSIONS.permission_office_officehours_add;
  const editOfficeHoursPermission =
    OFFICE_PERMISSIONS.permission_office_officehours_edit;
  //Office Dates
  const viewOfficeDates = OFFICE_PERMISSIONS.permission_office_dates_view;
  const addOfficeDates = OFFICE_PERMISSIONS.permission_office_dates_add;
  const editOfficeDates = OFFICE_PERMISSIONS.permission_office_dates_edit;
  //Office BI&A
  const viewOfficeBIA = OFFICE_PERMISSIONS.permission_office_bia_view;
  const addOfficeBIA = OFFICE_PERMISSIONS.permission_office_bia_add;
  const editOfficeBIA = OFFICE_PERMISSIONS.permission_office_bia_edit;

  //Telecom section
  const viewOfficeTelecom = OFFICE_PERMISSIONS.permission_office_telecom_view;
  const addOfficeTelecom = OFFICE_PERMISSIONS.permission_office_telecom_add;
  const editOfficeTelecom = OFFICE_PERMISSIONS.permission_office_telecom_edit;

  //Office Facilities
  const viewOfficeFacilities =
    OFFICE_PERMISSIONS.permission_office_facilities_view;
  const addOfficeFacilities =
    OFFICE_PERMISSIONS.permission_office_facilities_add;
  const editOfficeFacilities =
    OFFICE_PERMISSIONS.permission_office_facilities_edit;

  const userPermissions = useRecoilValue(permissionsSelector);
  const [isSaving, setIsSaving] = useState(false);
  const { mutateAsync: sendEmail } = useSendEmail();
  const [, setAttachments] = useRecoilState<(File | null)[]>(
    officeImageAttachment
  );
  const [imageForDelete, setImageForDelete] =
    useRecoilState<any>(fileImageForDelete);
  const [rowForDelete, setRowForDelete] =
    useRecoilState<any>(rowImageForDelete);
  const [onchangeToUpdateList, setOnchangeToUpdateList] =
    useRecoilState(changeToUpdate);
  const useFormMethods = useForm<any>({
    defaultValues: { ...rowForEdit },
  });

  // Employee Reports To
  const { data: empReportsToCount } = useGetEmployeeReportsCount(
    rowForEdit?.officeCode
  );
  const [selectedEmployee] = useRecoilState(associatedEmployeeId);
  const [fromEmployeeReportsTo] = useRecoilState(fromEmpReportsModal);

  const {
    reset,
    clearErrors,
    formState: { isDirty },
    setValue,
    watch,
  } = useFormMethods;
  const [showFromOH, setShowFromOH] = useRecoilState(officeFromOH);
  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
  const [isDisabled, setIsDisabled] = useRecoilState(disabled);
  const [employeeAssociatedToOffice, setEmployeeAssociatedToOffice] =
    useState<any>();
  const { data: officeStatusData } = useGetActiveOfficeStatus();

  const activeOfficeStatus = officeStatusData?.map((b) => {
    return {
      label: b.status,
      value: b.officeStatusId,
    };
  });

  useEffect(() => {
    const officeStatus = activeOfficeStatus?.filter(
      (x) => x.label?.toLowerCase() === "pending"
    )[0];
    if (isAddState) {
      reset({
        officeStatusId: officeStatus?.value,
        officeStatus: officeStatus?.label,
        createdBy: user.email,
        accountOwner: user.email,
        shippingLocation: "",
        billingLocation: "",
      });
    }
    if (isEditState) {
      if (rowForEdit?.isFranchise === true) {
        setFranchiseCheckBoxValue(true);
      } else {
        setFranchiseCheckBoxValue(false);
      }
      if (
        !rowForEdit?.officeStatus?.includes("Close") ||
        !rowForEdit?.officeStatus?.includes("Dark")
      ) {
        if (rowForEdit?.mondayStoreHours !== "Closed") {
          setValue("mondayStoreHours", "Open");
        }
        if (rowForEdit?.tuesdayStoreHours !== "Closed") {
          setValue("tuesdayStoreHours", "Open");
        }
        if (rowForEdit?.wednesdayStoreHours !== "Closed") {
          setValue("wednesdayStoreHours", "Open");
        }
        if (rowForEdit?.thursdayStoreHours !== "Closed") {
          setValue("thursdayStoreHours", "Open");
        }
        if (rowForEdit?.fridayStoreHours !== "Closed") {
          setValue("fridayStoreHours", "Open");
        }
        if (rowForEdit?.saturdayStoreHours !== "Closed") {
          setValue("saturdayStoreHours", "Open");
        }
        if (rowForEdit?.sundayStoreHours !== "Closed") {
          setValue("sundayStoreHours", "Open");
        }
      } else {
        setValue("mondayStoreHours", "Closed");
        setValue("tuesdayStoreHours", "Closed");
        setValue("wednesdayStoreHours", "Closed");
        setValue("thursdayStoreHours", "Closed");
        setValue("fridayStoreHours", "Closed");
        setValue("saturdayStoreHours", "Closed");
        setValue("sundayStoreHours", "Closed");
      }
      setValue("currentOfficeStatus", rowForEdit?.officeStatus);
    }
  }, [officeStatusData]);

  useEffect(() => {
    if (empOffice) {
      setEmployeeAssociatedToOffice(
        empOffice
          ?.filter(
            (x) =>
              x.employeeOfficeCode === watch("officeCode") &&
              !x.employeeStatusName?.includes("Terminated")
          )
          ?.filter(
            (y) =>
              y.employeeOfficeCode === watch("officeCode") &&
              !y.employeeStatusName?.includes("RecordDeleted")
          )
      );
    }
  }, [empOffice]);

  const controlledFields = watch("fileImageLists");
  const onSubmit = (data: IOfficeDetails) => {
    //Existing fields
    let cFieldsCount =
      controlledFields?.filter((x) => x.imageCategoryId && x.imageLabelId)
        ?.length > 0
        ? controlledFields?.length
        : 0;
    //New fields w/ only has 1 value in field
    let newFieldCount =
      controlledFields?.filter((x) => x.imageCategoryId || x.imageLabelId)
        ?.length > 0
        ? controlledFields?.length
        : 0;
    //Remove values in field w/ attachments
    let isNull = controlledFields?.filter(
      (x) => x.imageCategoryId === null || x.imageLabelId === null
    );
    //For delete both fields and image
    let forDelete = imageForDelete.filter((x) => x !== undefined);
    //For delete only image
    let forDeleteImage = rowForDelete.filter((x) => x !== undefined);

    //Office hours Section
    const officeHoursData: Pick<IOfficeDetails, keyof IOfficeHoursList> = {
      mondayStoreHours:
        data.mondayStoreHours === "Closed"
          ? "Closed"
          : data.mondayStartTime + "-" + data.mondayEndTime,
      tuesdayStoreHours:
        data.tuesdayStoreHours === "Closed"
          ? "Closed"
          : data.tuesdayStartTime + "-" + data.tuesdayEndTime,
      wednesdayStoreHours:
        data.wednesdayStoreHours === "Closed"
          ? "Closed"
          : data.wedsStartTime + "-" + data.wedsEndTime,
      thursdayStoreHours:
        data.thursdayStoreHours === "Closed"
          ? "Closed"
          : data.thursStartTime + "-" + data.thursEndTime,
      fridayStoreHours:
        data.fridayStoreHours === "Closed"
          ? "Closed"
          : data.fridayStartTime + "-" + data.fridayEndTime,
      saturdayStoreHours:
        data.saturdayStoreHours === "Closed"
          ? "Closed"
          : data.satStartTime + "-" + data.satEndTime,
      sundayStoreHours:
        data.sundayStoreHours === "Closed"
          ? "Closed"
          : data.sunStartTime + "-" + data.sunEndTime,
      mondayStartTime: data.mondayStartTime,
      mondayEndTime: data.mondayEndTime,
      tuesdayStartTime: data.tuesdayStartTime,
      tuesdayEndTime: data.tuesdayEndTime,
      wedsStartTime: data.wedsStartTime,
      wedsEndTime: data.wedsEndTime,
      thursStartTime: data.thursStartTime,
      thursEndTime: data.thursEndTime,
      fridayStartTime: data.fridayStartTime,
      fridayEndTime: data.fridayEndTime,
      satStartTime: data.satStartTime,
      satEndTime: data.satEndTime,
      sunStartTime: data.sunStartTime,
      sunEndTime: data.sunEndTime,
    };
    //Office Hierarchy and Leadership Section
    const officeHierarchyDetails: Pick<
      IOfficeDetails,
      keyof IOfficeHierarchyDeatils
    > = {
      regionName: data.regionName,
      areaName: data.areaName,
      areaCode: data.areaCode,
      salesVp: data.salesVp,
      regionCode: data.regionCode,
      districtCode: data.districtCode,
      districtName: data.districtName,
      territoryCode: data.territoryCode,
      territoryName: data.territoryName,
      districtManager: data.districtManager,
      officeHierarchyEffectiveDate: data.officeHierarchyEffectiveDate
        ? new Date(data.officeHierarchyEffectiveDate).toISOString()
        : null,
      branchManagerId: data.branchManagerId,
      branchManagerName: data.branchManagerName,
      businessConsultantId: data.businessConsultantId,
      businessConsultantName: data.businessConsultantName,
      franchiseOwner: data.franchiseOwner,
      franchiseDetailsId: data.franchiseDetailsId,
      franchiseDetails: data.franchiseDetails,
    };

    setNewData({
      ...data,
      generalInformationSection: [data],
      officeHoursSection: [officeHoursData],
      officeHierarchyAndLeadershipSection: [officeHierarchyDetails],
      officeDetails: [data],
      fileImageForDelete: forDelete,
      fileImages: forDeleteImage,
      onchangeToUpdate: onchangeToUpdateList,
      mondayStoreHours:
        data.mondayStoreHours === "Closed"
          ? "Closed"
          : data.mondayStartTime + "-" + data.mondayEndTime,
      tuesdayStoreHours:
        data.tuesdayStoreHours === "Closed"
          ? "Closed"
          : data.tuesdayStartTime + "-" + data.tuesdayEndTime,
      wednesdayStoreHours:
        data.wednesdayStoreHours === "Closed"
          ? "Closed"
          : data.wedsStartTime + "-" + data.wedsEndTime,
      thursdayStoreHours:
        data.thursdayStoreHours === "Closed"
          ? "Closed"
          : data.thursStartTime + "-" + data.thursEndTime,
      fridayStoreHours:
        data.fridayStoreHours === "Closed"
          ? "Closed"
          : data.fridayStartTime + "-" + data.fridayEndTime,
      saturdayStoreHours:
        data.saturdayStoreHours === "Closed"
          ? "Closed"
          : data.satStartTime + "-" + data.satEndTime,
      sundayStoreHours:
        data.sundayStoreHours === "Closed"
          ? "Closed"
          : data.sunStartTime + "-" + data.sunEndTime,
      officeHierarchyEffectiveDate: data.officeHierarchyEffectiveDate
        ? new Date(data.officeHierarchyEffectiveDate).toISOString()
        : null,
      officeClosedDate: data.officeClosedDate
        ? new Date(data.officeClosedDate).toISOString()
        : null,
      isFranchise:
        data.officeType?.toLowerCase() === "franchise" ? true : false,
      createdBy:
        data.createdBy === undefined ? user.emailAddress : data.createdBy,
      finessePeripheralSet: data.finessePeripheralSet
        ? data.finessePeripheralSet
        : 0,
    });
    //validate if eligble to open
    if (watch("officeStatus").includes("Open")) {
      if (
        watch("officeName") &&
        watch("officeTypeId") &&
        watch("storeNumber") &&
        watch("officeCode") &&
        watch("officeStatusDetails") &&
        watch("phone") &&
        watch("bmoId") &&
        watch("address") &&
        watch("stateCode") &&
        watch("city") &&
        watch("zipCode") &&
        watch("officeDivisionCodeId") &&
        watch("glBranch") &&
        (watch("mondayStoreHours") ||
          watch("tuesdayStoreHours") ||
          watch("wednesdayStoreHours") ||
          watch("thursdayStoreHours") ||
          watch("fridayStoreHours") ||
          watch("saturdayStoreHours") ||
          watch("sundayStoreHours"))
      ) {
        if (
          watch("mondayStoreHours")?.toLowerCase() !== "closed" ||
          watch("tuesdayStoreHours")?.toLowerCase() !== "closed" ||
          watch("wednesdayStoreHours")?.toLowerCase() !== "closed" ||
          watch("thursdayStoreHours")?.toLowerCase() !== "closed" ||
          watch("fridayStoreHours")?.toLowerCase() !== "closed" ||
          watch("saturdayStoreHours")?.toLowerCase() !== "closed" ||
          watch("sundayStoreHours")?.toLowerCase() !== "closed"
        ) {
          if (
            cFieldsCount !== imageDisplay?.length ||
            (isNull?.length > 0 && controlledFields?.length > 1) ||
            (newFieldCount !== imageDisplay?.length &&
              controlledFields?.length === 1)
          ) {
            toast.fire(
              "Saving Failed",
              "Please fill image category, image label field and choose image.",
              "warning"
            );
            setIsSaving(false);
          } else if (
            watch("officeStatus") === "Closed" &&
            employeeAssociatedToOffice?.length > 0
          ) {
            toast.fire(
              "Saving Failed",
              "Please re-assign new office to Employees associated to this office",
              "warning"
            );
            setIsSaving(false);
            setIsDisabled(true);
          } else if (isAddState) {
            setSaveModal(true);
          } else if (
            (isEditState && isDirty) ||
            imageForDelete?.length > 0 ||
            rowForDelete?.length > 0
          ) {
            if (managerChanged && empReportsToCount > 0) {
              setReportsToConfirmationModal(true);
            } else {
              setSaveModal(true);
            }
          } else {
            setIsSaving(false);
            if (!isDirty) {
              toast.fire(
                "Saving Failed",
                "No changes have been made.",
                "warning"
              );
            }
          }
        }
      } else {
        toast.fire(
          "Cannot select office status.",
          "Office is not yet eligible to open, please complete all required fields.",
          "error"
        );
      }
    } else {
      if (cFieldsCount !== imageDisplay?.length) {
        toast.fire("Saving Failed", "Please choose an image.", "warning");
        setIsSaving(false);
      } else if (
        (newFieldCount !== imageDisplay?.length &&
          controlledFields?.length === 1) ||
        (isNull?.length > 0 && controlledFields?.length > 1)
      ) {
        toast.fire(
          "Saving Failed",
          "Please fill image category and label field.",
          "warning"
        );
        setIsSaving(false);
      } else if (
        watch("officeStatus") === "Closed" &&
        employeeAssociatedToOffice?.length > 0
      ) {
        toast.fire(
          "Saving Failed",
          "Please re-assign new office to Employees associated to this office",
          "warning"
        );
        setIsSaving(false);
        setIsDisabled(true);
      } else if (isAddState) {
        setSaveModal(true);
      } else if (
        (isEditState && isDirty) ||
        imageForDelete?.length > 0 ||
        rowForDelete?.length > 0
      ) {
        if (managerChanged && empReportsToCount > 0) {
          setReportsToConfirmationModal(true);
        } else {
          setSaveModal(true);
        }
      } else {
        setIsSaving(false);
        if (!isDirty) {
          toast.fire("Saving Failed", "No changes have been made.", "warning");
        }
      }
    }
  };

  const handleSave = () => {
    setIsSaving(true);
    setSaveModal(false);
    if (isAddState) {
      addofficeSettings(newData, {
        onSuccess: (addResult) => {
          if (addResult.data === "duplicate") {
            setIsSaving(false);
            toast.fire("Failed", "Office record already exists.", "error");
          } else if (addResult.status === 201 || addResult.status === 200) {
            sendEmail(addResult.data, {
              onSuccess: (res) => {
                if (res) {
                  if (addResult.status === 400) {
                    toast.fire(
                      "Success",
                      "Office added successfully, but failed in sending email.",
                      "warning"
                    );
                  } else {
                    toast.fire(
                      "Success",
                      "Office added successfully.",
                      "success"
                    );
                  }
                  queryClient.invalidateQueries("GetSFOffice");
                  queryClient.invalidateQueries("OfficeSettings");
                  searchRefetch();
                  handleCancel();
                } else {
                  toast.fire(
                    "Success",
                    "Office added successfully, but failed in sending email.",
                    "warning"
                  );
                  queryClient.invalidateQueries("GetSFOffice");
                  queryClient.invalidateQueries("OfficeSettings");
                  searchRefetch();
                  handleCancel();
                }
              },
            });
          } else if (addResult.status !== 201 && addResult.status !== 200) {
            if (
              addResult.data === "Failed sending of email" ||
              addResult.data === "Failed inserting of notification"
            ) {
              toast.fire(
                "Warning",
                "New office added successfully, but " + addResult.data,
                "warning"
              );
              queryClient.invalidateQueries("GetSFOffice");
              queryClient.invalidateQueries("OfficeSettings");
              searchRefetch();
              handleCancel();
            } else {
              toast.fire(
                "Warning",
                "Potential issue with either adding of record or mail sending. Kindly verify if data was saved.",
                "warning"
              );
            }
            queryClient.invalidateQueries("GetSFOffice");
            queryClient.invalidateQueries("OfficeSettings");
          } else {
            toast.fire(
              "Server Error",
              "Failed to add office! No data saved.",
              "error"
            );
            queryClient.invalidateQueries("GetSFOffice");
            queryClient.invalidateQueries("OfficeSettings");
          }
        },
        onError: () => {
          toast.fire(
            "Server Error",
            "Failed to add office! No data saved.",
            "error"
          );
          queryClient.invalidateQueries("GetSFOffice");
          queryClient.invalidateQueries("OfficeSettings");
        },
      });
    } else {
      //Adds selected employee id from Employee Reports To modal
      const updatedData = fromEmployeeReportsTo
        ? { ...newData, associatedEmployeeIds: selectedEmployee }
        : newData;
      editofficeSettings(updatedData, {
        onSuccess: (editResult) => {
          queryClient.invalidateQueries("GetSFOffice");
          queryClient.invalidateQueries("GetOfficeSettings");
          if (editResult && editResult.data === "duplicate") {
            toast.fire("Failed", "Office record already exists.", "error");
            setIsSaving(false);
          } else if (
            (editResult && editResult.status === 201) ||
            editResult.status === 200
          ) {
            sendEmail(editResult.data, {
              onSuccess: (res) => {
                if (res) {
                  if (editResult.status === 400) {
                    toast.fire(
                      "Success",
                      "Office updated successfully, but failed in sending email.",
                      "warning"
                    );
                  } else {
                    toast.fire(
                      "Success",
                      "Office updated successfully.",
                      "success"
                    );
                  }
                  queryClient.invalidateQueries("GetSFOffice");
                  queryClient.invalidateQueries("GetOfficeSettings");
                  setIsSaving(false);
                  setShowState(false);
                  searchRefetch();
                  handleCancel();
                } else {
                  toast.fire(
                    "Success",
                    "Office updated successfully, but failed in sending email.",
                    "warning"
                  );
                  queryClient.invalidateQueries("GetSFOffice");
                  queryClient.invalidateQueries("GetOfficeSettings");
                  setShowState(false);
                  searchRefetch();
                  handleCancel();
                }
              },
            });
          } else if (editResult.status === 500 || editResult.status === 400) {
            const errorMessage = editResult.data.message
              ? editResult.data.message
              : editResult.data;

            if (
              errorMessage === "Failed sending of email" ||
              errorMessage === "Failed inserting of notification" ||
              errorMessage.includes("Service not available")
            ) {
              toast.fire(
                "Warning",
                "Office updated successfully, but " +
                  errorMessage +
                  " or failed sending of email",
                "warning"
              );
              searchRefetch();
              setIsSaving(false);
              handleCancel();
            } else {
              toast.fire(
                "Failed",
                "Failed to update office! No data saved.",
                "error"
              );
            }
            queryClient.invalidateQueries("GetSFOffice");
            queryClient.invalidateQueries("OfficeSettings");
          } else {
            toast.fire(
              "Server Error",
              "Failed to update office! No data saved.",
              "error"
            );

            setIsSaving(false);
          }
        },
        onError: () => {
          toast.fire(
            "Server Error",
            "Failed to update office! No data saved.",
            "error"
          );
          queryClient.invalidateQueries("GetSFOffice");
          queryClient.invalidateQueries("OfficeSettings");
          setIsSaving(false);
        },
      });
    }
  };
  const handleCancel = () => {
    //Handles Cancel if from OfficeHierarchy
    if (showFromOH) {
      setShowFromOH(false);
      setShowState(false);
      const url = "/carrieragreementmgmt/officehierarchy";
      history.push("officehierarchy");
      const index = CarrierAgreementMgmtTabs.findIndex((c) => c.to === url);
      setSelectedIndex(index);
    }
    //End
    setIsSaving(false);
    clearErrors();
    setRowToEdit(undefined);
    setAddState(false);
    setEditState(false);
    setValidWorkFromHome(false);
    setImageForDelete([]);
    setAttachments([]);
    setRowForDelete([]);
    setOnchangeToUpdateList([]);
    setIsDisabled(false);
    setManagerChanged(false);
  };

  const handleReportsToModal = () => {
    setShowEmployeeReportsTo(true);
    setReportsToConfirmationModal(false);
  };

  const closeReportsToModal = () => {
    setShowEmployeeReportsTo(false);
  };

  return (
    <>
      <div className="p-3 space-y-2 border-l-2 border-primary box-shadow mt-2">
        <FormProvider {...useFormMethods}>
          <form onSubmit={useFormMethods.handleSubmit(onSubmit)}>
            <div className="flex flex-row  justify-between items-center text-quinary font-bold font-sans text-lg pb-2">
              <div className="ml-2 font-bold text-primary text-md">
                {isAddState ? "Add Office Settings" : "Edit Office Settings"}
              </div>
              <div className="flex justify-between gap-2 mr-2">
                <SubmitHookForm
                  type="submit"
                  disabled={isSaving || isDisabled}
                  buttonText={isSaving ? "Saving.." : "Save"}
                  className={undefined}
                  onClick={undefined}
                />
                <CancelButton
                  onClick={() => {
                    handleCancel();
                  }}
                />
              </div>
            </div>
            <div className="mx-2 border-b-2 border-secondary"></div>
            <div className="flex justify-between mt-3 mb-3">
              <div className="text-xs text-secondary italic font-normal ml-2">
                <b> Note:</b> All fields with * are required to fill.
              </div>
            </div>
            <div className="bg-bgDB">
              {(userPermissions.includes(viewGeneralInfoPermission) ||
                (userPermissions.includes(addGeneralInfoPermission) &&
                  isAddState) ||
                (userPermissions.includes(editGeneralInfoPermission) &&
                  isEditState)) && (
                <div>
                  <OfficeGeneralInfo
                    disableFields={
                      isEditState &&
                      userPermissions.includes(viewGeneralInfoPermission) &&
                      !userPermissions.includes(addGeneralInfoPermission) &&
                      !userPermissions.includes(editGeneralInfoPermission)
                    }
                    rowForEdit={rowForEdit}
                  />
                </div>
              )}
              {watch("channelC") !== "SPLC"
                ? (userPermissions.includes(viewOfficeHierarchyPermission) ||
                    (userPermissions.includes(editOfficeHierarchyPermission) &&
                      isEditState)) && (
                    <div>
                      <OfficeHierarchy
                        disableFields={
                          isEditState &&
                          userPermissions.includes(
                            viewOfficeHierarchyPermission
                          ) &&
                          !userPermissions.includes(
                            editOfficeHierarchyPermission
                          )
                        }
                      />
                    </div>
                  )
                : (userPermissions.includes(viewSplcHierarchyPermission) ||
                    (userPermissions.includes(editSplcHierarchyPermission) &&
                      isEditState)) && (
                    <div>
                      <SPLCHierarchy
                        disableFields={
                          isEditState &&
                          userPermissions.includes(
                            viewSplcHierarchyPermission
                          ) &&
                          !userPermissions.includes(editSplcHierarchyPermission)
                        }
                      />
                    </div>
                  )}
              {(userPermissions.includes(viewOfficeAddress) ||
                (userPermissions.includes(addOfficeAddress) && isAddState) ||
                (userPermissions.includes(editOfficeAddress) &&
                  isEditState)) && (
                <>
                  <div>
                    <OfficeAddress
                      disableFields={
                        isEditState &&
                        userPermissions.includes(viewOfficeAddress) &&
                        !userPermissions.includes(addOfficeAddress) &&
                        !userPermissions.includes(editOfficeAddress)
                      }
                    />
                  </div>
                  <div>
                    <OfficeMappingData
                      disableFields={
                        isEditState &&
                        userPermissions.includes(viewOfficeAddress) &&
                        !userPermissions.includes(addOfficeAddress) &&
                        !userPermissions.includes(editOfficeAddress)
                      }
                    />
                  </div>
                </>
              )}
              {(userPermissions.includes(viewOfficeHoursPermission) ||
                (userPermissions.includes(addOfficeHoursPermission) &&
                  isAddState) ||
                (userPermissions.includes(editOfficeHoursPermission) &&
                  isEditState)) && (
                <OfficeHours
                  disableFields={
                    isEditState &&
                    userPermissions.includes(viewOfficeHoursPermission) &&
                    !userPermissions.includes(addOfficeHoursPermission) &&
                    !userPermissions.includes(editOfficeHoursPermission)
                  }
                />
              )}
              {(isAddState || isEditState) && (
                <div>
                  <OfficeImageSectionForm
                    fileImagesList={
                      rowForEdit?.fileImageLists &&
                      rowForEdit?.fileImageLists?.length > 0
                        ? rowForEdit?.fileImageLists
                        : undefined
                    }
                    isAddState={isAddState}
                  />
                </div>
              )}
              {(userPermissions.includes(viewOfficeDates) ||
                (userPermissions.includes(addOfficeDates) && isAddState) ||
                (userPermissions.includes(editOfficeDates) && isEditState)) && (
                <div>
                  <OfficeDates
                    disableFields={
                      isEditState &&
                      userPermissions.includes(viewOfficeDates) &&
                      !userPermissions.includes(addOfficeDates) &&
                      !userPermissions.includes(editOfficeDates)
                    }
                  />
                </div>
              )}

              {(userPermissions.includes(viewOfficeBIA) ||
                (userPermissions.includes(addOfficeBIA) && isAddState) ||
                (userPermissions.includes(editOfficeBIA) && isEditState)) && (
                <OfficeBIandA
                  disableFields={
                    isEditState &&
                    userPermissions.includes(viewOfficeBIA) &&
                    !userPermissions.includes(addOfficeBIA) &&
                    !userPermissions.includes(editOfficeBIA)
                  }
                />
              )}

              {(userPermissions.includes(viewOfficeFacilities) ||
                (userPermissions.includes(addOfficeFacilities) && isAddState) ||
                (userPermissions.includes(editOfficeFacilities) &&
                  isEditState)) && (
                <OfficeFacilities
                  disableFields={
                    isEditState &&
                    userPermissions.includes(viewOfficeFacilities) &&
                    !userPermissions.includes(addOfficeFacilities) &&
                    !userPermissions.includes(editOfficeFacilities)
                  }
                />
              )}

              {(userPermissions.includes(viewOfficeTelecom) ||
                (userPermissions.includes(addOfficeTelecom) && isAddState) ||
                (userPermissions.includes(editOfficeTelecom) &&
                  isEditState)) && (
                <OfficeTelecom
                  isEditState={isEditState}
                  isAddState={isAddState}
                  disableFields={
                    isEditState &&
                    userPermissions.includes(viewOfficeTelecom) &&
                    !userPermissions.includes(addOfficeTelecom) &&
                    !userPermissions.includes(editOfficeTelecom)
                  }
                />
              )}
            </div>
          </form>
        </FormProvider>
      </div>

      {saveModal && (
        <ConfirmBoxModal
          ModalTitle={
            isAddState ? "Add Office Settings" : "Edit Office Settings"
          }
          qConfirmation={`Are you sure you want to ${
            isAddState ? "add " : "update "
          } this data?`}
          isOpen={saveModal}
          onClose={() => {
            setSaveModal(false);
            setIsSaving(false);
          }}
          onClickFunction={() => {
            handleSave();
          }}
          cancelButtonRef={undefined}
        />
      )}

      {reportsToConfirmationModal && (
        <ConfirmBoxModal
          ModalTitle={
            "Replacing the Branch Manager will cause changes to the Employee Reports To field."
          }
          qConfirmation={"Are you sure you want to update this?"}
          isOpen={reportsToConfirmationModal}
          onClose={() => {
            setReportsToConfirmationModal(false);
            setSaveModal(true);
          }}
          onClickFunction={() => {
            handleReportsToModal();
          }}
          cancelButtonRef={undefined}
        />
      )}

      {showEmployeeReportsTo && (
        <EmployeeReportsToModal
          officeCode={rowForEdit?.officeCode}
          showEmployeeReportsTo={showEmployeeReportsTo}
          closeReportsToModal={closeReportsToModal}
          setSaveModal={setSaveModal}
        />
      )}
    </>
  );
};

export default OfficeSettingsForm;
